
export function getSepaRequestBody () {
  return {
    InitiationContext: {
      targetSchemeNm: 'STEP2',
      saveOnError: false,
      sourceId: 'DOB'
    },
    CstmrCdtTrfInitn: {
      GrpHdr: {
        CreDtTm: ''
      },
      PmtInf: [
        {
          PmtTpInf: {
            InstrPrty: 'NORM',
            LclInstrm: {
              Cd: 'CREDITTRANSFER'
            }
          },
          ReqdExctnDt: '',
          Dbtr: {
            Nm: '',
            Id: {
              PrvtId: {
                Othr: [
                  {
                    Id: ''
                  }
                ]
              }
            }
          },
          DbtrAcct: {
            Id: {
              Othr: {
                Id: ''
              }
            }
          },
          CdtTrfTxInf: [
            {
              PmtId: {
                InstrId: '',
                EndToEndId: ''
              },
              Amt: {
                InstdAmt: {
                  Amt: '',
                  Ccy: ''
                },
                EqvtAmt: {
                  CcyOfTrf: ''
                }
              },
              CdtrAgt: {
                FinInstnId: {
                  BICFI: ''
                }
              },
              Cdtr: {
                Nm: '',
                PstlAdr: {
                  AdrTp: 'ADDR',
                  Ctry: ''
                }
              },
              CdtrAcct: {
                Id: {
                  IBAN: ''
                }
              }
            }
          ]
        }
      ]
    }
  }
}
